import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchOperatorsAlerts: ['filter', 'offset'],
  fetchOperatorsAlertsLoading: null,
  fetchOperatorsAlertsLoadingMore: null,
  fetchOperatorsAlertsSuccess: ['offset', 'alerts', 'nextOffset'],
  fetchOperatorsAlertsFail: ['error'],

  fetchAlertChargePoints: ['filter', 'offset'],
  fetchAlertChargePointsLoading: null,
  fetchAlertChargePointsLoadingMore: null,
  fetchAlertChargePointsSuccess: ['offset', 'chargePoints', 'nextOffset'],
  fetchAlertChargePointsFail: ['error'],

  setAlertChargePointsFilter: ['filter'],
  resetAlertChargePoints: null,
  setClickedOperatorAlert: ['rowData'],

  editAlert: ['alertId', 'alert'],
  editAlertLoading: null,
  editAlertSuccess: ['alert'],
  editAlertFail: ['error'],

  deleteAlert: ['alertId'],
  deleteAlertLoading: null,
  deleteAlertSuccess: ['alertId'],
  deleteAlertFail: ['error'],

  createAlert: ['alert'],
  createAlertLoading: null,
  createAlertSuccess: ['alert'],
  createAlertFail: ['error'],

  fetchAlertCount: ['filter'],
  fetchOperatorsAlertsCountLoading: null,
  fetchOperatorsAlertsCountSuccess: ['count'],
  fetchOperatorsAlertsCountFail: ['error'],

  setOperatorAlertFilter: ['filter'],
  clearOperatorAlerts: null,
  resetEditingStates: null,
})

export const OperatorsAlertTypes = Types
export default Creators
